export default __webpack_public_path__ + "static/media/warning_icon.e4f3696e.svg";